import { useQuery } from '@tanstack/react-query';
import { getDasContributions } from '../../../services/das.service';

export const useDasContributions = (filters = null, enabled = false) => {
  return useQuery({
    queryKey: [
      'dasContributions',
      filters?.policyNumber || filters?.policy_number || 'all',
      filters?.memberNumber || filters?.member_number || 'all',
      filters?.fundYear || filters?.fund_year || 'all',
      filters?.date_from || '',
      filters?.date_to || ''
    ],
    queryFn: () => getDasContributions(filters),
    enabled: !!enabled && !!filters,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 1,
    onError: (error) => {
      console.error('Error fetching DAS contributions:', error);
    }
  });
};
